import { createSelector } from 'reselect';
import { isFetching } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { StudioSection, AppState } from '../../types/store';
import { STASH_SUBFOLDERS_STREAM } from '../../../constants';
import { getActiveSection, getSelectedFolder, getStudioParams } from './page';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';

export function getIsBusy(state: AppState) {
  return (
    isFetching(state, STASH_SUBFOLDERS_STREAM.streamId) || state.studio?.folders?.status === 'busy'
  );
}

export const getIsGalleryRootFolder = createSelector(
  [getActiveSection, getStudioParams, getSelectedFolder],
  (activeSection, params, selectedFolder) =>
    activeSection === StudioSection.PUBLISHED_GALLERIES &&
    !selectedFolder?.parentId &&
    !params.subfolderId
);

export const getIsRootFolder = createSelector(
  [getActiveSection, getStudioParams, getSelectedFolder],
  (activeSection, params, selectedFolder) =>
    [StudioSection.STASH, StudioSection.PUBLISHED, StudioSection.PUBLISHED_GALLERIES].includes(
      activeSection
    ) &&
    selectedFolder?.folderId !== SCRAPS_FOLDER_ID &&
    !selectedFolder?.parentId &&
    !params.subfolderId
);
